export default {
  title: {
    create: 'Neues virtuelles Signal',
    edit: 'Signal Einstellungen',
  },
  tabs: {
    signal: 'Virtuelle Signaleinstellungen',
    preset: 'Voreinstellungen',
    metadata: 'Signaleinstellungen',
  },
};
